import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import PinSetup from "@/pages/PinSetup";
import Unlock from "@/pages/Unlock";
import MerchantDashboard from "@/pages/MerchantDashboard";
import ReceiveQR from "@/pages/ReceiveQR";
import ReceiveManual from "@/pages/ReceiveManual";
import ReceiveNFC from "@/pages/ReceiveNFC";
import ReceiveCash from "@/pages/ReceiveCash";
import CustomerPay from "@/pages/CustomerPay";
import History from "@/pages/History";
import OnlinePay from "@/pages/OnlinePay";
import WalletTopUp from "@/pages/WalletTopUp";
import Plans from "@/pages/Plans";
import MerchantSettings from "@/pages/MerchantSettings";
import { BottomNav } from "@/components/BottomNav";
import AuthCallback from "@/pages/AuthCallback";
import Assistant from "@/pages/Assistant";
import { storage } from "@/lib/storage";

const Guard = ({ children }) => {
  const { pathname } = useLocation();
  if (!storage.getUser() || !storage.hasPin()) return <Navigate to="/" replace />;
  if (!storage.isUnlocked()) {
    const role = pathname === "/customer" ? "customer" : "merchant";
    return <Navigate to={`/unlock?role=${role}&next=${encodeURIComponent(pathname)}`} replace />;
  }
  storage.touchUnlock();
  return children;
};

const HIDE_NAV = ["/", "/pin-setup", "/unlock"];

const Chrome = () => {
  const { pathname } = useLocation();
  const show = !HIDE_NAV.includes(pathname) && storage.getUser() && storage.hasPin() && storage.isUnlocked();
  return show ? <BottomNav /> : null;
};

const AppRouter = () => {
  const { hash } = useLocation();
  if (hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pin-setup" element={<PinSetup />} />
          <Route path="/unlock" element={<Unlock />} />
          <Route path="/merchant" element={<Guard><MerchantDashboard /></Guard>} />
          <Route path="/receive/qr" element={<Guard><ReceiveQR /></Guard>} />
          <Route path="/receive/manual" element={<Guard><ReceiveManual /></Guard>} />
          <Route path="/receive/nfc" element={<Guard><ReceiveNFC /></Guard>} />
          <Route path="/receive/cash" element={<Guard><ReceiveCash /></Guard>} />
          <Route path="/customer" element={<Guard><CustomerPay /></Guard>} />
          <Route path="/history" element={<Guard><History /></Guard>} />
          <Route path="/online-pay" element={<Guard><OnlinePay /></Guard>} />
          <Route path="/wallet" element={<Guard><WalletTopUp /></Guard>} />
          <Route path="/plans" element={<Guard><Plans /></Guard>} />
          <Route path="/settings" element={<Guard><MerchantSettings /></Guard>} />
          <Route path="/assistant" element={<Guard><Assistant /></Guard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Chrome />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "rgba(28, 36, 60, 0.95)",
            border: "1px solid rgba(230, 180, 85, 0.3)",
            color: "#F7E6B4",
          },
        }}
      />
    </div>
  );
}

export default App;
